<span>
  <cap-kompakt-beleg-icp
    [capHistinfo]="histInfo"
    [format]="belegTypTemplate"
    [id]="rechtsgrund.rechtsgrundZusatz"
    [isEigentuemer]="isEigentuemer"
    [item]="rechtsgrund.beleg"
    [referenzObjectId]="rechtsgrund?.rechtsgrundId?.id"
    [referenzObjectType]="'RECHTSGRUND'"
    [showBeleg]="showBeleg"></cap-kompakt-beleg-icp>
  <cap-read-more [histInfo]="histInfo" [limit]="textLimit" [text]="text"> </cap-read-more>
</span>
